import { AxiosInstance } from "axios";
import CommonCRUD from "modules/CommonCRUD";

class Roles extends CommonCRUD {}

export default Roles;
